import { useState } from "react";
import axios from "axios";

const gold = "#c8a96e";
const EMPTY = { name: "", cost: "", price: "", platform: "", sale_date: "", notes: "" };

export default function Tracker({ sales, onRefresh }) {
  const [form, setForm] = useState(EMPTY);
  const [adding, setAdding] = useState(false);
  const [saving, setSaving] = useState(false);

  const totalRevenue = sales.reduce((s, d) => s + (d.price || 0), 0);
  const totalCost = sales.reduce((s, d) => s + (d.cost || 0), 0);
  const profit = totalRevenue - totalCost;
  const avgROI = sales.length ? (sales.reduce((s, d) => s + (d.cost ? ((d.price - d.cost) / d.cost * 100) : 0), 0) / sales.length).toFixed(0) : 0;

  const inp = { width: "100%", boxSizing: "border-box", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8, padding: "10px 12px", color: "#fff", fontSize: 13, outline: "none", marginBottom: 10, fontFamily: "inherit" };
  const lbl = { color: "#777", fontSize: 11, marginBottom: 4, display: "block" };

  async function add() {
    if (!form.name) return;
    setSaving(true);
    await axios.post("/api/sales", { ...form, cost: parseFloat(form.cost) || 0, price: parseFloat(form.price) || 0 });
    setForm(EMPTY); setAdding(false); setSaving(false); onRefresh();
  }

  async function remove(id) {
    if (!window.confirm("حذف هذه المبيعة؟")) return;
    await axios.delete(`/api/sales/${id}`);
    onRefresh();
  }

  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 12, marginBottom: 24 }}>
        {[["مبيعات", sales.length, gold], ["إجمالي الربح", `$${profit.toFixed(0)}`, profit >= 0 ? "#8bc4a8" : "#c47c7c"], ["إجمالي الإيراد", `$${totalRevenue.toFixed(0)}`, "#7c9cba"], ["متوسط ROI", `${avgROI}%`, "#a89c7c"]].map(([l, v, c]) => (
          <div key={l} style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 12, padding: "14px 10px", textAlign: "center" }}>
            <div style={{ color: c, fontWeight: 700, fontSize: 18 }}>{v}</div>
            <div style={{ color: "#555", fontSize: 11, marginTop: 4 }}>{l}</div>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <span style={{ color: "#666", fontSize: 13 }}>سجل المبيعات</span>
        <button onClick={() => setAdding(!adding)}
          style={{ background: gold, color: "#0f0d0a", border: "none", borderRadius: 8, padding: "9px 18px", fontWeight: 700, cursor: "pointer", fontSize: 13 }}>
          {adding ? "إلغاء" : "+ مبيعة جديدة"}
        </button>
      </div>

      {adding && (
        <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(200,169,110,0.25)", borderRadius: 16, padding: 20, marginBottom: 20 }}>
          <div style={{ color: gold, fontWeight: 700, fontSize: 13, marginBottom: 16 }}>◆ تسجيل مبيعة</div>

          <label style={lbl}>اسم الدومين *</label>
          <input placeholder="example.com" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} style={{ ...inp, direction: "ltr" }} />

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div><label style={lbl}>سعر الشراء ($)</label>
              <input type="number" placeholder="10" value={form.cost} onChange={(e) => setForm({ ...form, cost: e.target.value })} style={{ ...inp, direction: "ltr" }} /></div>
            <div><label style={lbl}>سعر البيع ($)</label>
              <input type="number" placeholder="500" value={form.price} onChange={(e) => setForm({ ...form, price: e.target.value })} style={{ ...inp, direction: "ltr" }} /></div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div><label style={lbl}>منصة البيع</label>
              <input placeholder="Sedo / Dan..." value={form.platform} onChange={(e) => setForm({ ...form, platform: e.target.value })} style={{ ...inp, direction: "ltr" }} /></div>
            <div><label style={lbl}>📅 تاريخ البيع</label>
              <input type="date" value={form.sale_date} onChange={(e) => setForm({ ...form, sale_date: e.target.value })} style={{ ...inp, direction: "ltr" }} /></div>
          </div>

          <label style={lbl}>ملاحظات</label>
          <textarea placeholder="ملاحظات اختيارية..." value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} style={{ ...inp, resize: "vertical", minHeight: 60 }} />

          <button onClick={add} disabled={saving}
            style={{ width: "100%", background: saving ? "#444" : gold, color: "#0f0d0a", border: "none", borderRadius: 10, padding: 13, fontWeight: 700, cursor: saving ? "not-allowed" : "pointer", fontSize: 14 }}>
            {saving ? "جارٍ الحفظ..." : "تسجيل المبيعة ◆"}
          </button>
        </div>
      )}

      {sales.length === 0 && !adding && (
        <div style={{ textAlign: "center", padding: "60px 0", color: "#444" }}>
          <div style={{ fontSize: 44, marginBottom: 14 }}>◆</div>
          <div>لم تُسجّل أي مبيعة بعد</div>
        </div>
      )}

      {[...sales].reverse().map((s) => {
        const p = (s.price || 0) - (s.cost || 0);
        const roi = s.cost ? ((p / s.cost) * 100).toFixed(0) : 0;
        return (
          <div key={s.id} style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 12, padding: 16, marginBottom: 10 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
              <span style={{ color: "#fff", fontWeight: 700, direction: "ltr" }}>{s.name}</span>
              <span style={{ color: p >= 0 ? "#8bc4a8" : "#c47c7c", fontWeight: 700, fontSize: 15 }}>+${p.toFixed(0)}</span>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
              {[`شراء: $${s.cost}`, `بيع: $${s.price}`, `ROI: ${roi}%`, s.platform, s.sale_date].filter(Boolean).map((t, i) => (
                <span key={i} style={{ color: "#666", fontSize: 12 }}>{t}</span>
              ))}
            </div>
            {s.notes && <div style={{ color: "#555", fontSize: 12, marginTop: 6, fontStyle: "italic" }}>{s.notes}</div>}
            <button onClick={() => remove(s.id)} style={{ marginTop: 10, background: "none", border: "none", color: "#444", cursor: "pointer", fontSize: 12 }}>حذف ✕</button>
          </div>
        );
      })}
    </div>
  );
}
